// Centralized preset icon mapping for consistency across components

export const PRESET_ICON_MAP: Record<string, string> = {
  default: 'blueprint',
  partner: 'briefcase',
  deployment: 'rocket',
  regional: 'globe-simple',
  environment: 'stack-simple',
  feature: 'flask',
  tenant: 'cloud'
}

/**
 * Returns the phosphor icon name for a preset type.
 * Falls back to 'question-mark' for unknown types.
 */
export function getPresetIcon(type: string | undefined | null): string {
  if (!type) {
    // console.debug('[presetIcons] getPresetIcon: empty type -> question-mark')
    return 'question-mark'
  }
  const raw = type
  const key = raw.toLowerCase().trim()
  const resolved = PRESET_ICON_MAP[key]
  if (!resolved) {
    // console.debug('[presetIcons] getPresetIcon: unmapped type', { raw, key, resolved: 'question-mark' })
    return 'question-mark'
  }
  // console.debug('[presetIcons] getPresetIcon: mapped', { raw, key, resolved })
  return resolved
}
